import React from 'react';

import { SVGComponentProps } from './svg.types';

const CustomUrlSvg = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          d="M13.491 1.66699H6.50768C3.47435 1.66699 1.66602 3.47533 1.66602 6.50866V13.4837C1.66602 16.5253 3.47435 18.3337 6.50768 18.3337H13.4827C16.516 18.3337 18.3243 16.5253 18.3243 13.492V6.50866C18.3327 3.47533 16.5243 1.66699 13.491 1.66699ZM13.641 11.9587L11.791 13.8087C11.341 14.2587 10.7577 14.4753 10.1743 14.4753C9.59102 14.4753 8.99935 14.2503 8.55768 13.8087C8.12435 13.3753 7.88268 12.8003 7.88268 12.192C7.88268 11.5837 8.12435 11.0003 8.55768 10.5753L9.73268 9.40033C9.97435 9.15866 10.3743 9.15866 10.616 9.40033C10.8577 9.64199 10.8577 10.042 10.616 10.2837L9.44102 11.4587C9.24102 11.6587 9.13268 11.917 9.13268 12.192C9.13268 12.467 9.24102 12.7337 9.44102 12.9253C9.84935 13.3337 10.5077 13.3337 10.916 12.9253L12.766 11.0753C13.8243 10.017 13.8243 8.30033 12.766 7.24199C11.7077 6.18366 9.99102 6.18366 8.93268 7.24199L6.91602 9.25866C6.49102 9.68366 6.25768 10.242 6.25768 10.8337C6.25768 11.4253 6.49102 11.992 6.91602 12.4087C7.15768 12.6503 7.15768 13.0503 6.91602 13.292C6.67435 13.5337 6.27435 13.5337 6.03268 13.292C5.36602 12.6503 4.99935 11.7753 4.99935 10.842C4.99935 9.90866 5.35768 9.03366 6.01602 8.37533L8.03268 6.35866C9.57435 4.81699 12.091 4.81699 13.6327 6.35866C15.1827 7.90033 15.1827 10.417 13.641 11.9587Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default CustomUrlSvg;
